import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";

export const checkActiveLogin = createAsyncThunk(
  "activeLogin/checkActiveLogin",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/EsignServices/CheckActiveLogin`);
      if (response.data.status) {
        return response.data.is_active;
      } else {
        return rejectWithValue("Inactive user");
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const activeLoginSlice = createSlice({
  name: "activeLogin",
  initialState: {
    is_active: false,
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(checkActiveLogin.pending, (state) => {
        state.status = "loading";
      })
      .addCase(checkActiveLogin.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.is_active = action.payload;
      })
      .addCase(checkActiveLogin.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default activeLoginSlice.reducer;
